module.exports = __webpack_public_path__ + "img/page_1.95f08dec.png";